<template>
  <!-- 待機当番管理 -->
  <div id="AppUrgentSchedule">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <!--検索条件 -->
    <div
      class="box"
      style="margin-left: 50px; margin-right: 50px;"
    >
      <div class="columns">
        <div class="column">
          <label class="searchTitle label">待機当番管理</label>
        </div>
      </div>
      <div class="columns">
        <div class="column is-one-second">
          <b-field
            label="営業所"
            labelPosition="on-border"
          >
            <b-select
              expanded
              v-model="selectedOffice"
              v-on:input="selectOffice()"
            >
              <option
                v-for="office in officeMaster"
                :value="office.officeCode"
                :key="office.officeCode"
              >{{ office.officeName }}</option>
            </b-select>
          </b-field>
        </div>
      </div>
      <!-- 検索実行ボタン-->
      <div
        class="columns"
        style="text-align:center;"
      >
        <div class="column">
          <b-button
            v-if="selectedOffice"
            class="button"
            type="is-primary"
            style="float:left;"
            icon-right="magnify"
            native-type="button"
            @click="search(1,true)"
          >{{getTeamName(1)}}</b-button>
          <b-button
            v-if="isActive&&selectedOffice"
            class="button"
            type="is-primary"
            style="float:left;margin-left:1%;"
            icon-right="magnify"
            native-type="button"
            @click="search(2,true)"
          >{{getTeamName(2)}}</b-button>
          <b-button
            v-if="srcRoleId == 1 || srcRoleId == 2"
            class="button is-primary has-text-centered"
            icon-left="download"
            native-type="button"
            style="float:right;"
            v-on:click="downloadModalActive=true"
          >ダウンロード</b-button>
          <b-modal
            :active.sync="downloadModalActive"
            has-modal-card
          >
            <schedule-download-modal
              v-on:set-history-check="historyCheckUpdate"
              v-bind:holiday="holidays"
              v-bind:attribute="attributes"
            ></schedule-download-modal>
          </b-modal>
          <b-button
            v-if="srcRoleId == 1 || srcRoleId == 2 || srcRoleId == 7"
            class="button"
            style="float:right;margin-right:10%;"
            type="is-primary"
            icon-left="folder-upload"
            native-type="button"
            v-on:click="getUrgentInChargeinformation(1)"
          >メイン/サブ管理</b-button>
          <b-modal
            :active.sync="isMainSubManagementActive"
            has-modal-card
            full-screen
          >
            <main-sub-management-modal
              v-bind:other-datas="otherData"
              v-bind:editFlag="isEdit"
              v-on:save-team-event="saveTeamList()"
            ></main-sub-management-modal>
          </b-modal>
        </div>
      </div>
      <div
        class="columns"
        style="text-align:center;"
      >
        <div class="column">
          <span
            style="color: red"
            v-if="isSearchConditionNull"
          >検索条件を指定してください。</span>
        </div>
      </div>
    </div>
    <!-- 検索結果 -->
    <div
      class="box"
      style="margin-left: 50px; margin-right: 50px;"
      v-if="searchedOffice"
    >
      <div>
        <div class="columns">
          <div class="column">
            <label
              class="searchTitle label"
              style="font-size: 30px"
            >
              {{headerYearMonth}} {{searchedOffice | fillterOfficeName(officeMaster)}} 待機当番表
              <br />
              <span style="font-size: 50px;position: relative;">{{fillterInChargeType}}</span>
            </label>
            <!-- TODO:表示条件 -->
            <!-- v-if="srcRoleId == 1 || srcRoleId == 2" -->
            <b-button
              class="button"
              type="is-primary"
              style="float:right;margin-right:1%;"
              icon-left
              native-type="button"
              v-on:click="getScheduleHisory()"
            >変更履歴検索</b-button>
            <b-modal
              :active.sync="historyModalActive"
              full-screen
            >
              <schedule-history-modal
                v-on:set-history-check="historyCheckUpdate"
                v-bind:app="appVue"
                v-bind:office="selectedOffice"
                v-bind:type="inChargeType"
                v-bind:history="historyData"
                v-bind:roleId="srcRoleId"
              ></schedule-history-modal>
            </b-modal>
          </div>
        </div>
        <template>
          <div
            class="columns"
            style="border-left: solid 1px;border-right: solid 1px;border-top: solid 1px; border-bottom: solid 1px; text-align:left;"
          >
            <div
              class="column is-half"
              style="border-right: solid 1px;"
            >
              <span style="text-align:left; margin-left:1%;">営業所呼吸メモ</span>
              <br />
              <b-field>
                <b-input
                  v-model="officeSchedule.officeRespiratoryMemo"
                  type="textarea"
                  name="nextDirection"
                  size="sm"
                  data-vv-as="定型メモ"
                  v-validate="'max:512'"
                  maxlength="512"
                  :readonly="!isEdit"
                ></b-input>
              </b-field>
            </div>
            <div class="column is-half">
              <span style="text-align:left; margin-left:1%;">営業所睡眠メモ</span>
              <br />
              <b-field>
                <b-input
                  v-model="officeSchedule.officeSleepMemo"
                  type="textarea"
                  name="nextDirection"
                  size="sm"
                  data-vv-as="定型メモ"
                  v-validate="'max:512'"
                  maxlength="512"
                  :readonly="!isEdit"
                ></b-input>
              </b-field>
            </div>
          </div>
          <br />
          <div
            class="columns"
            style="border-left: solid 1px;border-right: solid 1px;border-top: solid 1px;"
          >
            <div
              class="column is-half"
              style="background: #89b5f0; text-align:left; border-right: solid 1px;"
            >
              <span style="font-size: 40px; margin-left:45%;font-weight: bold;color: #ff0000;">呼吸</span>
              <br />
              <span style="font-size: 30px">所属：{{officeSchedule.respiratoryOfficeCode | fillterOfficeName(officeFilterMaster)}}</span>
              <br />
              <span style="font-size: 30px">{{getHeader(officeSchedule.respiratoryStaffName,officeSchedule.respiratoryStaffNameKana,officeSchedule.respiratoryPositionCode)}}</span>
              <br />
              <span style="font-size: 40px; color: #0000FF;font-weight: bold;">電話番号：{{officeSchedule.respiratoryStaffPhoneNumber}}</span>
            </div>
            <div
              class="column is-half"
              style="background: papayawhip; text-align:left; "
            >
              <span style="font-size: 40px; margin-left:45%;font-weight: bold;color: #ff0000;">睡眠</span>
              <br />
              <span style="font-size: 30px">所属：{{officeSchedule.sleepOfficeCode | fillterOfficeName(officeFilterMaster)}}</span>
              <br />
              <span style="font-size: 30px">{{getHeader(officeSchedule.sleepStaffName,officeSchedule.sleepStaffNameKana,officeSchedule.sleepPositionCode)}}</span>
              <br />
              <span style="font-size: 40px; color: #0000FF;font-weight: bold;">電話番号：{{officeSchedule.sleepStaffPhoneNumber}}</span>
              <br />
              <span style="font-size: 40px; color: #0000FF;font-weight: bold;">当番携帯：{{officeSchedule.sleepPhoneNumber}}</span>
            </div>
          </div>
          <div
            class="columns"
            style="border-right: solid 1px;border-left: solid 1px; border-bottom: solid 1px; text-align:left;"
          >
            <div
              class="column is-half"
              style="background: #89b5f0; border-right: solid 1px;"
            >
              <span style="text-align:left; margin-left:1%;">メモ</span>
              <br />
              <b-field>
                <b-input
                  v-model="respiratoryStaffMemo"
                  type="textarea"
                  name="nextDirection"
                  size="sm"
                  data-vv-as="当日呼吸担当者メモ"
                  v-validate="'max:512'"
                  maxlength="512"
                  :readonly="!isEdit"
                ></b-input>
              </b-field>
            </div>
            <div
              class="column is-half"
              style="background: papayawhip;"
            >
              <span style="text-align:left; margin-left:1%;">メモ</span>
              <br />
              <b-field>
                <b-input
                  v-model="sleepStaffMemo"
                  type="textarea"
                  name="nextDirection"
                  size="sm"
                  data-vv-as="当日睡眠担当者メモ"
                  v-validate="'max:512'"
                  maxlength="512"
                  :readonly="!isEdit"
                ></b-input>
              </b-field>
            </div>
          </div>
          <b-button
            v-if="isEdit"
            class="button is-primary has-text-centered"
            icon-left="folder-upload"
            native-type="button"
            v-on:click="save"
          >登録</b-button>
          <div style="height: 10px;" />
          <vc-calendar
            is-expanded
            :attributes="attributes"
            style="width:100%; height: 100%;"
            :min-date="startDate"
            :max-date="endDate"
            :first-day-of-week="2"
            v-bind:key="renderKey"
            :from-page="{ month: workMonth, year: targetYear }"
            @update:fromPage="pageChange"
          >
            <template
              slot="header-title"
              slot-scope="page"
            >{{page.yearLabel}}年{{page.monthLabel}}</template>
            <template
              slot="day-content"
              slot-scope="props"
            >
              <div
                class="vc-border"
                is-expanded
              >
                <div>
                  <div style="border-bottom: 1px solid #ccc">
                    <div v-bind:style="addHolidaysStyle(props.day.weekday,props.day)">{{ props.day.day }}</div>
                  </div>
                </div>
                <a v-if="isEdit" @click="changeSelectStaff('respiratoryStaff', props.day.id) ">
                  <div class="scheduleItem respiratoryDiv">
                    <div class="kindMark kind">
                      <div class="kindLabel">呼</div>
                    </div>
                    <div class="scheduledName">{{getuserName(getRespiratoryStaffInfo(props.day.id, 'name'),16)}}</div>
                  </div>
                </a>
                <div v-else>
                  <div class="scheduleItem respiratoryDiv">
                    <div class="kindMark kind">
                      <div class="kindLabel">呼</div>
                    </div>
                    <div class="scheduledName">{{getuserName(getRespiratoryStaffInfo(props.day.id, 'name'),16)}}</div>
                  </div>
                </div>
                <a v-if="isEdit" @click="changeSelectStaff('sleepStaff', props.day.id)">
                  <div class="scheduleItem sleepDiv">
                    <div class="kindMark kind">
                      <div class="kindLabel">睡</div>
                    </div>
                    <div class="scheduledName">{{getuserName(getSleepStaffInfo(props.day.id, 'name'),16)}}</div>
                  </div>
                </a>
                <div v-else>
                  <div class="scheduleItem sleepDiv">
                    <div class="kindMark kind">
                      <div class="kindLabel">睡</div>
                    </div>
                    <div class="scheduledName">{{getuserName(getSleepStaffInfo(props.day.id, 'name'),16)}}</div>
                  </div>
                </div>
              </div>
            </template>
          </vc-calendar>
          <div style="height: 10px;" />
          <!-- TODO: 多分要らない
          <b-button
            class="button is-primary has-text-centered"
            icon-left="folder-upload"
            native-type="button"
            v-on:click="save"
          >登録</b-button>-->
          <b-button
            v-if="isEdit"
            class="button is-primary has-text-centered"
            icon-left="calendar-multiple"
            native-type="button"
            v-on:click="showBulkScheduleModal()"
          >当番一括設定</b-button>
          <b-modal
            :active.sync="isBulkScheduleModalActive"
            has-modal-card
          >
            <bulk-schedule-modal
              ref="bulkModal"
              v-bind:all-menber-list="data"
              v-bind:office-master="officeFilterMaster"
              v-bind:start-date="startDate"
              v-bind:end-date="endDate"
              v-bind:holiday-list="holidays"
              v-bind:respiratory-schedule="respiratorySchedule"
              v-bind:sleep-schedule="sleepSchedule"
              v-bind:year="targetYear"
              v-bind:month="workMonth"
              v-on:bulk-schedule-event="bulkSchedule"
            ></bulk-schedule-modal>
          </b-modal>
          <div style="height: 10px;" />
          <div class="columns">
            <div class="column">
              <label
                class="searchTitle label"
                style="font-size: 30px"
              >支店マネージャー／営業所リーダー</label>
            </div>
          </div>
          <div
            style="margin-top:20px;"
            class="columns"
          >
            <div class="column is-half">
              <b-field
                label="支店所呼吸マネージャー"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('respiratoryManager')}"
                :message="errors.first('respiratoryManager')"
              >
                <b-input
                  style="width:100%;"
                  name="respiratoryManager"
                  v-model="respiratoryManager"
                  :readonly="true"
                  data-vv-validate-on="input"
                  v-validate="'required'"
                  data-vv-as="支店所呼吸マネージャー"
                ></b-input>
                <b-button
                  v-if="isEdit"
                  style="float:right"
                  class="button is-primary has-text-centered"
                  icon-left="account-switch"
                  native-type="button"
                  v-on:click="chengeStaff('respiratoryManager')"
                ></b-button>
              </b-field>
            </div>
            <div class="column is-half">
              <b-field
                label="営業所呼吸リーダー"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('respiratoryLeader')}"
                :message="errors.first('respiratoryLeader')"
              >
                <b-input
                  style="width:100%;"
                  name="respiratoryLeader"
                  v-model="respiratoryLeader"
                  :readonly="true"
                  data-vv-validate-on="input"
                  data-vv-as="営業所呼吸リーダー"
                ></b-input>
                <b-button
                  v-if="isEdit"
                  style="float:right"
                  class="button is-primary has-text-centered"
                  icon-left="account-switch"
                  native-type="button"
                  v-on:click="chengeStaff('respiratoryLeader')"
                ></b-button>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column is-half">
              <b-field
                label="支店睡眠マネージャー"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('sleepManager')}"
                :message="errors.first('sleepManager')"
              >
                <!-- 睡眠はまだ使用しない為、コメントアウト：v-validate="'required'" -->
                <b-input
                  style="width:100%;"
                  name="sleepManager"
                  v-model="sleepManager"
                  :readonly="true"
                  data-vv-validate-on="input"
                  data-vv-as="支店睡眠マネージャー"
                ></b-input>
                <b-button
                  v-if="isEdit"
                  style="float:right"
                  class="button is-primary has-text-centered"
                  icon-left="account-switch"
                  native-type="button"
                  v-on:click="chengeStaff('sleepManager')"
                ></b-button>
              </b-field>
            </div>
            <div class="column is-half">
              <b-field
                label="営業所睡眠リーダー"
                labelPosition="on-border"
                :type="{'is-danger':errors.has('sleepLeader')}"
                :message="errors.first('sleepLeader')"
              >
                <b-input
                  style="width:100%;"
                  name="sleepLeader"
                  v-model="sleepLeader"
                  :readonly="true"
                  data-vv-validate-on="input"
                  data-vv-as="営業所睡眠リーダー"
                ></b-input>
                <b-button
                  v-if="isEdit"
                  style="float:right"
                  class="button is-primary has-text-centered"
                  icon-left="account-switch"
                  native-type="button"
                  v-on:click="chengeStaff('sleepLeader')"
                ></b-button>
              </b-field>
            </div>
          </div>
          <div class="columns">
            <div class="column">
              <label
                class="searchTitle label"
                style="font-size: 30px"
              >待機当番リスト</label>
            </div>
          </div>
          <div>
            <b-table
              :data="data"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page"
            >
              <template slot-scope="props">
                <b-table-column
                  field="type"
                  label="呼吸/睡眠"
                  sortable
                  centered
                  style="font-size: 14px;"
                >{{ props.row.type | fillterType() }}</b-table-column>
                <b-table-column
                  field="dutyStaffName"
                  label="氏名 (フリガナ)"
                  sortable
                  centered
                  style="font-size: 14px;"
                >{{ props.row.dutyStaffName }} ({{props.row.dutyStaffNameKana}})</b-table-column>
                <b-table-column
                  field="dutyMobilePhoneNumber"
                  label="電話番号"
                  sortable
                  centered
                  style="font-size: 14px;"
                >{{ props.row.dutyMobilePhoneNumber }}</b-table-column>
                <b-table-column
                  field="salesOfficeCode"
                  label="所属営業所"
                  sortable
                  centered
                  style="font-size: 14px;"
                >{{ props.row.salesOfficeCode | fillterOfficeName(officeFilterMaster) }}</b-table-column>

                <b-table-column
                  field="lastMonthInCharge"
                  label="前月当番日数"
                  sortable
                  centered
                  style="font-size: 14px;"
                >{{ props.row.lastMonthInCharge}}</b-table-column>
                <b-table-column
                  field="thisMonthInCharge"
                  label="当月当番日数"
                  sortable
                  centered
                  style="font-size: 14px;"
                >{{ props.row.thisMonthInCharge}}</b-table-column>
                <b-table-column
                  field="nextMonthInCharge"
                  label="翌月当番日数"
                  sortable
                  centered
                  style="font-size: 14px;"
                >{{ props.row.nextMonthInCharge}}</b-table-column>
              </template>
            </b-table>
          </div>
        </template>
        <b-modal
          :active.sync="isStaffChangeModalActive"
          has-modal-card
        >
          <staffChange-modal
            v-bind:flg="isStaffChangeModalFlag"
            v-bind:office-code="selectedOffice"
            v-on:staff-change-event="staffChanged"
            v-on:staff-delete-event="staffDelete"
            v-on:staff-set="staffSet"
          ></staffChange-modal>
        </b-modal>
        <b-modal
          :active.sync="isSelectStaffModal"
          has-modal-card
        >
          <!-- 
            v-on:staff-set="staffSet"
            v-bind:flg="isStaffChangeModalFlag"
          -->
          <select-staff-modal
            v-bind:data-master="dutyListData"
            v-bind:office-master="officeFilterMaster"
            v-bind:target="changedTarget.id"
            v-bind:type="changedTarget.type"
            v-on:staff-delete-event="staffDelete"
            v-on:staff-change-event="staffChanged"
          ></select-staff-modal>
        </b-modal>
      </div>
      <div style="height: 10px;" />
      <div style="text-align:center;">
        <b-button
          v-if="isEdit"
          class="button is-primary has-text-centered"
          icon-left="folder-upload"
          native-type="button"
          v-on:click="save"
        >登録</b-button>
        <b-button
          v-if="srcRoleId != 6 && srcRoleId != 7"
          class="button is-primary has-text-centered"
          icon-left="folder-upload"
          native-type="button"
          v-on:click="editInChargeList()"
        >待機当番リスト編集</b-button>
        <b-modal
          :active.sync="isInChargeListModalActive"
          has-modal-card
          full-screen
        >
          <in-charge-list-modal
            v-bind:objInChageList="objInChageList"
            v-on:save-in-charge-list="registrationIncharge()"
          ></in-charge-list-modal>
        </b-modal>
        <!-- <b-button
          v-if="roleId != 2"
          class="button is-primary has-text-centered"
          icon-left="folder-upload"
          native-type="button"
          v-on:click="getUrgentInChargeinformation(0)"
        >定型文簡易情報登録画面</b-button>
        <b-modal :active.sync="isTemplateMessageActive" has-modal-card>
          <template-messeage-modale
            v-bind:otherData="otherData"
            v-on:save-template-message="saveTemplateMessage()"
          ></template-messeage-modale>
        </b-modal>-->
      </div>
    </div>
  </div>
</template>

<script>
import StaffSearchTemplate from "./AppSelectStaff";

const inChargeListModal = {
  props: ["objInChageList"],
  data() {
    return {};
  },
  filters: {
    fillterOfficeName: function(val, officeMaster) {
      var office = officeMaster.find(v => v.officeCode === val);
      if (office) {
        return office.officeName;
      }
      return "";
    },
    inChargeTypeFillter(val) {
      let inChargeType;
      if (val == 1) {
        inChargeType = "メイン";
      } else if (val == 2) {
        inChargeType = "サブ";
      }
      return inChargeType;
    }
  },
  methods: {
    addListPush() {
      this.objInChageList.inChargeList.push({
        index: this.objInChageList.inChargeList.length
      });
    },
    changeOrder(index, type) {
      var target = [];
      var ahead;
      var former;
      var changeId;
      if (type == "up") {
        ahead = index - 1;
        former = index;
        changeId = index - 1;
      } else if (type == "down") {
        ahead = index + 1;
        former = index;
        changeId = index + 1;
      }

      for (var i = 0; i < this.objInChageList.inChargeList.length; i++) {
        switch (i) {
          case ahead:
            target.push(this.objInChageList.inChargeList[index]);
            break;
          case former:
            target.push(this.objInChageList.inChargeList[changeId]);
            break;
          default:
            target.push(this.objInChageList.inChargeList[i]);
            break;
        }
      }
      this.objInChageList.inChargeList = [];
      this.objInChageList.inChargeList = target;
    },
    selectStaff(index) {
      this.$parent.$parent.addIndex = index;
      this.$parent.$parent.openSelectStaff();
      // 担当者選択モーダルより下に表示したい為、Z-indexを下げる
      this.$parent.$el.style.zIndex = 10;
    },
    saveInchageList() {
      var isIllegalFlag = false;

      // 睡眠当番携帯番号チェック
      // 睡眠はまだ使用しない為、コメントアウト
      // if (
      //   !this.objInChageList.sleepPhoneNumber ||
      //   this.objInChageList.sleepPhoneNumber.length <= 0
      // ) {
      //   this.$validator.errors.add({
      //     field: "sleepPhoneNumber",
      //     msg: "睡眠当番携帯は必須項目です。"
      //   });
      //   isIllegalFlag = true;
      // }

      // 空行の削除
      this.objInChageList.inChargeList = this.objInChageList.inChargeList.filter(
        val => val.dutyStaffId || val.type || val.dutyMobilePhoneNumber
      );

      var isLengthZero = false;
      if (this.objInChageList.inChargeList.length == 0) {
        this.objInChageList.inChargeList.push({
          index: this.objInChageList.inChargeList.length
        });
        isLengthZero = true;
      }

      // 重複チェック
      if (!this.checkDuplication()) {
        return;
      }
      for (var i = 0; this.objInChageList.inChargeList.length > i; i++) {
        if (!isLengthZero && !this.objInChageList.inChargeList[i].type) {
          var name = this.getTypeFieldName(i);
          this.$validator.errors.add({
            field: name,
            msg: "種別は必須項目です。"
          });
          isIllegalFlag = true;
        }
        if (!isLengthZero && !this.objInChageList.inChargeList[i].dutyStaffId) {
          var userName = this.getUserNameFieldName(i);
          var officeName = this.getOfficeFieldName(i);
          this.$validator.errors.add({
            field: userName,
            msg:
              "名前、営業所は必須項目です。<br>詳細から担当者を選択してください。"
          });
          this.$validator.errors.add({
            field: officeName,
            msg: " "
          });
          isIllegalFlag = true;
        }
        if (
          !isLengthZero &&
          !this.objInChageList.inChargeList[i].dutyMobilePhoneNumber
        ) {
          var name = this.getUserPhoneFieldName(i);
          this.$validator.errors.add({
            field: name,
            msg: "電話番号は必須項目です。"
          });
          isIllegalFlag = true;
        }
        // 整形
        this.objInChageList.inChargeList[i].index = i;
        this.objInChageList.inChargeList[i].type = Number(
          this.objInChageList.inChargeList[i].type
        );
      }

      if (!isIllegalFlag) {
        // 空行の削除
        this.objInChageList.inChargeList = this.objInChageList.inChargeList.filter(
          val => val.dutyStaffId || val.type
        );
        this.$emit("save-in-charge-list");
        this.$parent.close();
      }
    },
    checkDuplication: function() {
      var duplication = this.objInChageList.inChargeList.filter(
        (x, y, z) =>
          z.slice(0, z.length).filter(w => w.dutyStaffId == x.dutyStaffId)
            .length >= 2
      );
      if (duplication.length > 0) {
        duplication = duplication.filter(function(v1, i1, a1) {
          return (
            a1.findIndex(function(v2) {
              return v1.dutyStaffId === v2.dutyStaffId;
            }) === i1
          );
        });

        var errMsg = "下記のユーザ情報が重複しています。<br>";
        for (var i in duplication) {
          errMsg = errMsg + duplication[i].dutyStaffName + "<br>";
        }
        this.showErrorMessage(errMsg);
        return false;
      }
      return true;
    },
    getTypeFieldName: function(index) {
      return "type_" + index;
    },
    getUserNameFieldName: function(index) {
      return "name_" + index;
    },
    getUserPhoneFieldName: function(index) {
      return "phone_" + index;
    },
    getOfficeFieldName: function(index) {
      return "office_" + index;
    },
    inputValue: function(name) {
      this.$validator.errors.remove(name);
      var typeIndex = Number(name.replace(/type_/g, ""));
      var phoneIndex = Number(name.replace(/phone_/g, ""));
      if (
        name.indexOf("type") == 0 &&
        this.objInChageList.inChargeList[typeIndex].type == ""
      ) {
        this.$validator.errors.remove("name_" + typeIndex);
        this.$validator.errors.remove("phone_" + typeIndex);
        this.$validator.errors.remove("office_" + typeIndex);
      }
      if (
        name.indexOf("phone") == 0 &&
        this.objInChageList.inChargeList[phoneIndex].type == ""
      ) {
        this.$validator.errors.remove("name_" + phoneIndex);
        this.$validator.errors.remove("type_" + phoneIndex);
        this.$validator.errors.remove("office_" + phoneIndex);
      }
    }
  },
  template: `
        <form style="width: 90%;height:30px;margin-left: 5%;">
          <div class="modal-card" style="width: 100%;">
          <div style="height: 10px;" />
            <header style="margin: 10px; width: 97%;">
                <label class="searchTitle label">待機当番リスト編集({{objInChageList.inChargeType|inChargeTypeFillter()}})</label>
                <label class="searchTitle label" style="text-align: left; padding-left:10px;">睡眠当番携帯</label>
            </header>
          <div style="height: 10px;" />          
            <div style="margin-left: 2%; width:50%">
              <b-field
                :type="{'is-danger':errors.has('sleepPhoneNumber')}"
                :message="errors.first('sleepPhoneNumber')"
                label="電話番号(携帯)"
                labelPosition="on-border"
              >
                <b-input
                  name="sleepPhoneNumber"
                  data-vv-as="睡眠電話番号"
                  maxlength="20"
                  v-model="objInChageList.sleepPhoneNumber"
                  v-on:input="inputValue('sleepPhoneNumber')"
                ></b-input>
              </b-field>
            </div>
            <div style="height: 15px;" />
            <section class="modal-card-body" style="width: 100%;height:900px;">
            <div style="margin: 10px; width: 97%;">
              <label class="searchTitle label" style="text-align: left; padding-left:10px;">待機当番リスト</label>
            </div>
            <tr v-for="(list, index) in objInChageList.inChargeList">
              <th v-if="index==objInChageList.inChargeList.length-1" style="margin-top:10%;width:5px;">
                <b-button
                  style="vertical-align:top; margin-right:10%;"
                  class="button is-primary has-text-centered"
                  icon-left="plus"
                  native-type="button"
                  v-on:click="addListPush()"
                ></b-button>
              </th>
              <th v-else style="margin-top:10%;width:5px;">
              </th>
              <td style="width:100%;padding-left:2%">
                <div class="columns">
                  <div class="column is-one-five">
                  <b-field label="種別"
                  :type="{'is-danger':errors.has(getTypeFieldName(index))}"
                  :message="errors.first(getTypeFieldName(index))"
                  labelPosition="on-border">
                    <b-select
                      expanded
                      name="getTypeFieldName(index)"
                      v-model="list.type"
                      style="margin-top:10%;"
                      data-vv-as="種別"
                      v-on:input="inputValue(getTypeFieldName(index))"
                    >
                      <option value=""></option>                   
                      <option value="1">呼吸</option>
                      <option value="2">睡眠</option>
                      <option value="3">呼吸/睡眠</option>
                    </b-select>
                    </b-field>
                  </div>
                  <div class="column is-one-five">
                  　<b-field
                    　:type="{'is-danger':errors.has(getUserNameFieldName(index))}"
                    　:message="errors.first(getUserNameFieldName(index))"
                    　labelPosition="on-border">
                    　<b-input
                      　expanded
                      　style="margin-top:10%;"
                      　name="getUserNameFieldName(index)"
                      　v-model="list.dutyStaffName"
                        v-on:input="inputValue(getTypeFieldName(index))"
                      　data-vv-as="名前"
                      　placeholder="名前"
                      　readonly
                    　　data-vv-validate-on="input"
                    　></b-input>
                    </b-field>
                  </div>
                  <div class="column is-one-five">
                  　<b-field
                    　:type="{'is-danger':errors.has(getOfficeFieldName(index))}"
                    　:message="errors.first(getOfficeFieldName(index))"
                    　labelPosition="on-border">
                    <b-input
                      expanded
                      style="margin-top:10%;"
                      v-model="list.salesOfficeName"
                      v-on:input="inputValue(getOfficeFieldName(index))"
                      data-vv-as="営業所"
                      placeholder="営業所"
                      readonly
                      data-vv-validate-on="input"
                    ></b-input>
                    </b-field>
                  </div>
                  <div class="column is-one-five">
                  　<b-field
                    　:type="{'is-danger':errors.has(getUserPhoneFieldName(index))}"
                    　:message="errors.first(getUserPhoneFieldName(index))"
                    　labelPosition="on-border">
                    <b-input
                      expanded
                      style="margin-top:10%;"
                      name="getUserPhoneFieldName(index)"
                      v-model="list.dutyMobilePhoneNumber"
                      v-on:input="inputValue(getUserPhoneFieldName(index))"
                      data-vv-as="電話番号"
                      placeholder="電話番号"
                      data-vv-validate-on="input"
                    ></b-input>
                  </b-field>
                  </div>
                  <div class="column is-one-five">
                    <b-button               
                      class="button is-primary has-text-centered"
                      style="margin-top:10%;"　　                              
                      native-type="button"
                      :id="'selectStaffButton'+index"
                      v-on:click="selectStaff(index)"
                    >詳細</b-button>
                    <b-button
                      v-if="objInChageList.inChargeList.length > 1"
                      style="margin-left:5px; margin-top:10%;"　
                      class="button is-primary has-text-centered"
                      icon-left="minus"
                      native-type="button"
                      v-on:click="objInChageList.inChargeList.splice(index, 1)"
                    ></b-button>
                    <b-button
                      v-if="index!=0"
                      class="button is-primary has-text-centered"
                      style="margin-top:10%;"　
                      icon-left="arrow-up-box"
                      native-type="button"
                      :id="'upOrderButton'+index"
                      v-on:click="changeOrder(index,'up')"
                    ></b-button>
                    <b-button
                      v-if="index!=objInChageList.inChargeList.length-1"
                      class="button is-primary has-text-centered"
                      style="margin-top:10%;"
                      icon-left="arrow-down-box"　　                              
                      native-type="button"
                      :id="'downOrderButton'+index"
                      v-on:click="changeOrder(index,'down')"
                    ></b-button>
                  </div>
                </div>
              </td>
            </tr>
            <div style="height: 10px;" />
          </section>
          <footer>
            <div style="height: 10px;" />
              <div style="text-align:center;">
                <b-button
                  class="button"
                  type="is-primary"
                  icon-left="keyboard-backspace"
                  native-type="button"
                  @click="$parent.close()"
                >戻る</b-button>
                <b-button
                  class="button is-primary has-text-centered"
                  icon-left="folder-upload"
                  v-on:click="saveInchageList()"
                  native-type="button"                  
                >登録</b-button>
              </div>
              <div style="height: 10px;" />
          </footer>
            </div>
        </form>
`
};

const mainSubManagementModal = {
  props: ["otherDatas","editFlag"],
  data() {
    var otherData = this.$props.otherDatas;
    return {
      otherData
    };
  },
  methods: {
    setTeamList: function() {
      var isIllegalFlag = false;
      for (var i = 0; i < this.otherData.urgentOfficeList.length; i++) {
        if (this.otherData.urgentOfficeList[i].subCheckFlag) {
          // サブ有りフラグがTRUEの場合、チーム名の必須チェック

          var targetMainName = this.otherData.urgentOfficeList[i].mainTeamName
            ? this.otherData.urgentOfficeList[i].mainTeamName.replace(
                /\s+/g,
                ""
              )
            : this.otherData.urgentOfficeList[i].mainTeamName;

          var targetSubName = this.otherData.urgentOfficeList[i].subTeamName
            ? this.otherData.urgentOfficeList[i].subTeamName.replace(/\s+/g, "")
            : this.otherData.urgentOfficeList[i].subTeamName;

          if (!targetMainName || targetMainName.length == 0) {
            var name = this.getMainFieldName(i);
            this.$validator.errors.add({
              field: name,
              msg: "メインチーム名称は必須項目です。"
            });
            isIllegalFlag = true;
          }
          if (!targetSubName || targetSubName.length == 0) {
            var name = this.getSubFieldName(i);
            this.$validator.errors.add({
              field: name,
              msg: "サブチーム名称は必須項目です。"
            });
            isIllegalFlag = true;
          }
        }
      }

      if (!isIllegalFlag) {
        this.$emit("save-team-event");
        this.$parent.close();
      }
    },
    getMainFieldName: function(index) {
      return "main_" + index;
    },
    getSubFieldName: function(index) {
      return "sub_" + index;
    },
    inputValue: function(name) {
      this.$validator.errors.remove(name);
    }
  },
  template: `
    <form style="width: 90%;height:30px;margin-left: 5%;margin-top: 1%;">
      <div class="modal-card" style="width: 100%;">
        <div style="height: 10px;" />
        <header>
          <label class="searchTitle label" style="text-align: left;margin-left:1%;margin-right:1%;padding-left:2%;">メインサブ管理</label>
        </header>
        <section class="modal-card-body" style="width: 100%;height:900px;">
          <div class="columns" style="width: 100%;">
            <div class="column is-1">サブ有り</div>
            <div class="column is-2">営業所コード</div>
            <div class="column is-3">営業所名</div>
            <div class="column is-3">メイン名称</div>
            <div class="column is-3">サブ名称</div>
          </div>
          <div v-for="(item, index) in otherData.urgentOfficeList">
            <div class="columns" style="margin-bottom:10px;width: 100%;border-top: 1px solid #d3d6db;">
              <div class="column is-1">
                <b-checkbox
                  :disabled="!editFlag"
                  style="margin-left:25%"
                  v-model="item.subCheckFlag"
                  name="subCheckFlag"
                ></b-checkbox>
              </div>
              <div class="column is-2" style="text-align:left;">
                <span style="margin-left:25%">{{item.officeCode}}</span>
              </div>
              <div class="column is-3" style="text-align:left;">
                <span style="margin-left:25%">{{item.officeName}}</span>
              </div>
              <div class="column is-3">
                <b-field
                :type="{'is-danger':errors.has(getMainFieldName(index))}"
                :message="errors.first(getMainFieldName(index))"
                labelPosition="on-border">
                  <b-input
                    :readonly="!editFlag"
                    v-model="item.mainTeamName"
                    name="getMainFieldName(index)"
                    data-vv-as="メイン名称"
                    placeholder="メイン名称"
                    v-on:input="inputValue(getMainFieldName(index))"
                  ></b-input>
                </b-field>
              </div>
              <div class="column is-3">
                <b-field
                :type="{'is-danger':errors.has(getSubFieldName(index))}"
                :message="errors.first(getSubFieldName(index))"
                labelPosition="on-border">
                  <b-input
                    :readonly="!editFlag"
                    v-model="item.subTeamName"
                    name="getSubFieldName(index)"
                    data-vv-as="サブ名称"
                    placeholder="サブ名称"
                    v-on:input="inputValue(getSubFieldName(index))"
                  ></b-input>
                </b-field>
              </div>
            </div>
          </div>
          <div style="height: 10px;" />
        </section>
        <footer>
          <b-button
            class="button"
            type="is-primary"
            native-type="button"
            v-on:click="$parent.close()"
          >戻る</b-button>
          <b-button
            v-if="editFlag"
            class="button"
            type="is-primary"
            native-type="button"
            v-on:click="setTeamList()"
          >登録</b-button>
          <div style="height: 10px;" />
        </footer>
      </div>
    </form>
`
};

const templateMesseageModale = {
  props: ["otherData"],
  data() {
    var data = this.$props.otherData;
    return {
      data
    };
  },
  methods: {
    saveMemo: function() {
      this.$emit("save-template-message", this.data);
      this.$parent.close();
    }
  },
  template: `
        <form action="">
          <div class="modal-card" style="width: 800px;">
          <div style="height: 10px;" />
            <header>
              <label class="searchTitle label" style="text-align: left; padding-left:10px;">定型文簡易情報登録</label>
            </header>
            <section class="modal-card-body">
            <label class="searchTitle label" style="text-align: left; padding-left:10px; width:100px">呼吸</label>
              <b-input
                type="textarea"
                name="nextDirection"
                size="sm"
                data-vv-as="呼吸"
                v-model=data.fixedFormRespiratoryMemo
                maxlength="512"
              ></b-input>
            <label class="searchTitle label" style="text-align: left; padding-left:10px; width:100px">睡眠</label>
              <b-input
                type="textarea"
                name="nextDirection"
                size="sm"
                data-vv-as="睡眠"
                v-model=data.fixedFormSleepMemo
                maxlength="512"
              ></b-input>
            </section>
            <footer>
              <div style="text-align:center;">
                <b-button
                  class="button"
                  type="is-primary"
                  icon-left="keyboard-backspace"
                  native-type="button"
                  v-on:click="$parent.close()"
                >戻る</b-button>
                <b-button
                  class="button is-primary has-text-centered"
                  icon-left="folder-upload"
                  native-type="button"
                  v-on:click="saveMemo()"
                >登録</b-button>
              </div>
              <div style="height: 10px;" />
            </footer>
          </div>
        </form>
      `
};
const ModalForm = {
  props: ["flg", "officeCode"],
  data() {
    var office = this.$props.officeCode;
    return {
      office,
      selected: false
    };
  },
  components: {
    staffSearch: StaffSearchTemplate
  },
  mounted() {
    var tergetOffice = {
      target: {
        value: this.office
      }
    };
    this.$refs.staffList.officeSelected(tergetOffice);
    // リスト編集モーダルより上に表示したい為、Z-indexを上げる
    if (this.$parent.$el.style != undefined) {
      this.$parent.$el.style.zIndex = 20;
    }
  },
  methods: {
    save: function(event) {
      if (this.flg) {
        // 選択されている担当者を取得
        var selectedStaff = this.$refs.staffList.getStaff();
        if (selectedStaff) {
          var editStaff = {
            type: null,
            dutyStaffId: selectedStaff.id,
            dutyStaffCode: selectedStaff.code,
            dutyStaffName:
              selectedStaff.lastName + selectedStaff.firstName,
            dutyStaffNameKana:
              selectedStaff.lastNameKana + selectedStaff.firstNameKana,
            dutyMobilePhoneNumber: selectedStaff.mobilePhoneNumber,
            salesOfficeCode: selectedStaff.officeCode,
            salesOfficeName: selectedStaff.officeName
          };
          //親画面のstaffChangedメソッドを呼び出し
          this.$emit("staff-set", editStaff);
          this.$parent.close();
        }
      } else {
        // 選択されている担当者を取得
        var selectedStaff = this.$refs.staffList.getStaff();
        if (selectedStaff) {
          //親画面のstaffChangedメソッドを呼び出し
          this.$emit("staff-change-event", selectedStaff);
          this.$parent.close();
        }
      }
    },
    deleteStaff: function(event) {
      this.$emit("staff-delete-event");
      this.$parent.close();
    }
  },
  template: `
        <form action="">
          <div class="modal-card" style="width: 800px;">
            <header class="modal-card-head">
                <p class="modal-card-title" style="color: whitesmoke;">担当者変更</p>
            </header>
            <section class="modal-card-body">
              <staffSearch
               ref="staffList"
               v-model="selected"
              />
            </section>
            <footer class="modal-card-foot">
                <button :disabled="!selected" class="button" type="button" @click="save">決定</button>
                <button class="button" type="button" @click="$parent.close()">閉じる</button>
                <button class="button" type="button" @click="deleteStaff">担当者クリア</button>
            </footer>
          </div>
        </form>
      `
};

const selectStaffModal = {
  props: ["dataMaster", "officeMaster", "target", "type"],
  data() {
    var checkedRows = [];
    var memo;
    if (this.target) {
      var selectItem = this.dataMaster.find(
        item => item.dutyStaffId == this.target
      );
      if (this.type == 1) {
        memo = selectItem ? selectItem.respiratoryMemo : "";
      } else if (this.type == 2) {
        memo = selectItem ? selectItem.sleepMemo : "";
      }
      checkedRows.push(selectItem);
    }
    return {
      checkedRows,
      memo
    };
  },
  components: {},
  mounted() {},
  watch: {
    checkedRows(list) {
      if (list.length > 1) {
        var target = list[list.length - 1];
        list = [];
        list.push(target);
        this.checkedRows = list;
      }
      if (this.type == 1) {
        this.memo = list[0].respiratoryMemo;
      } else if (this.type == 2) {
        this.memo = list[0].sleepMemo;
      }
    }
  },
  methods: {
    save: function(event) {
      // 選択されている担当者を取得
      if (this.checkedRows.length != 1) {
        // 複数選択の場合はメッセージ
        this.$dialog.alert({
          title: "　",
          message: "ユーザを1件選択してください。"
        });
        return;
      }
      if (this.checkedRows[0]) {
        var staffInfo = {
          id: this.checkedRows[0].dutyStaffId,
          lastName: this.checkedRows[0].dutyStaffName.split(" ")[0],
          firstName: this.checkedRows[0].dutyStaffName.split(" ")[1],
          mobilePhoneNumber: this.checkedRows[0].dutyMobilePhoneNumber,
          nameKana: this.checkedRows[0].dutyStaffNameKana,
          positionCode: this.checkedRows[0].positionCode,
          officeCode: this.checkedRows[0].salesOfficeCode,
          respiratoryMemo:
            this.type == 1 ? this.memo : this.checkedRows[0].respiratoryMemo,
          sleepMemo: this.type == 2 ? this.memo : this.checkedRows[0].sleepMemo
        };
        //親画面のstaffChangedメソッドを呼び出し
        this.$emit("staff-change-event", staffInfo);
        this.$parent.close();
      }
    },
    deleteStaff: function(event) {
      this.$emit("staff-delete-event");
      this.$parent.close();
    }
  },
  filters: {
    fillterOfficeName: function(val, officeMaster) {
      var office = officeMaster.find(v => v.officeCode === val);
      if (office) {
        return office.officeName;
      }
      return "";
    },
    fillterType: function(val) {
      switch (val) {
        case 1:
          return "呼吸";
          break;
        case 2:
          return "睡眠";
          break;
        case 3:
          return "呼吸/睡眠";
          break;
        default:
          return "";
          break;
      }
    }
  },
  template: `
        <form action="">
          <div class="modal-card" style="width: 800px;">
            <header class="modal-card-head">
                <p class="modal-card-title" style="color: whitesmoke;">担当者変更</p>
            </header>
            <section class="modal-card-body">
              <template>
                <div style="height:350px;">
                  <!-- 担当者選択 -->
                  <div class="columns is-vcentered">
                    <div style="width:100%;">
                      <b-table
                        :data="dataMaster"
                        checkable
                        :header-checkable="false"
                        :checked-rows.sync="checkedRows"
                      >
                        <template slot-scope="props">
                          <b-table-column
                            field="type"
                            label="呼吸/睡眠"
                            sortable
                            centered
                          >{{ props.row.type | fillterType() }}</b-table-column>
                          <b-table-column
                            field="dutyStaffName"
                            label="氏名 (フリガナ)"
                            sortable
                            centered
                          >{{ props.row.dutyStaffName }} ({{props.row.dutyStaffNameKana}})</b-table-column>
                          <b-table-column
                            field="salesOfficeCode"
                            label="所属営業所"
                            sortable
                            centered
                          >{{ props.row.salesOfficeCode | fillterOfficeName(officeMaster) }}</b-table-column>
                          <b-table-column
                            field="salesOfficeCode"
                            label="前月"
                            sortable
                            centered
                          >{{ props.row.lastMonthInCharge}}</b-table-column>
                          <b-table-column
                            field="salesOfficeCode"
                            label="当月"
                            sortable
                            centered
                          >{{ props.row.thisMonthInCharge}}</b-table-column>
                          <b-table-column
                            field="salesOfficeCode"
                            label="翌月"
                            sortable
                            centered
                          >{{ props.row.nextMonthInCharge}}</b-table-column>
                        </template>
                      </b-table>
                    </div>
                  </div>
                </div>
              </template>
            </section>
            <section class="modal-card-body">
              <div style="border-bottom: solid 1px;" />
              <label class="searchTitle label" style="text-align: left; padding-left:10px; margin-top:2px; width:100px">メモ</label>
              <b-input
                type="textarea"
                name="sleepMemo"
                size="sm"
                data-vv-as="担当者メモ"
                v-model="memo"
                maxlength="512"
              ></b-input>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="save">決定</button>
                <button class="button" type="button" @click="$parent.close()">閉じる</button>
                <button class="button" type="button" @click="deleteStaff">担当者クリア</button>
            </footer>
          </div>
        </form>
      `
};

const BulkScheduleModal = {
  props: [
    "allMenberList",
    "officeMaster",
    "startDate",
    "endDate",
    "holidayList",
    "respiratorySchedule",
    "sleepSchedule",
    "year",
    "month"
  ],
  data() {
    //呼吸のメンバー
    var respiratoryStaffList = this.allMenberList.filter(
      val => val.type == 1 || val.type == 3
    );
    //睡眠のメンバー
    var sleepStaffList = this.allMenberList.filter(
      val => val.type == 2 || val.type == 3
    );
    //選択肢にでてくるメンバー
    var staffList = respiratoryStaffList;

    return {
      attributes: [],
      respiratoryStaffList: respiratoryStaffList,
      sleepStaffList: sleepStaffList,
      staffList: staffList,
      selectDays: [],
      selectType: "respiratoryStaff", //初期値は呼吸
      selectedStaff: null,
      targetYear:this.year,
      targetMonth:this.month
    };
  },
  components: {},
  mounted() {},
  watch: {
    selectType: function() {
      //種別が変更されたら担当者をクリア
      this.selectedStaff = null;
      if (this.selectType == "respiratoryStaff") {
        //呼吸が選択された場合、選択肢を呼吸メンバーに変更
        this.staffList = this.respiratoryStaffList;
      } else {
        //睡眠が選択された場合、選択肢を睡眠メンバーに変更
        this.staffList = this.sleepStaffList;
      }
    }
  },
  methods: {
    save: function(event) {
      //担当者未入力チェック
      if (!this.selectedStaff) {
        this.$dialog.alert({
          title: "　",
          message: "担当者を選択してください。"
        });
        return;
      }
      //日付未選択チェック
      if (!this.selectDays || this.selectDays.length < 1) {
        this.$dialog.alert({
          title: "　",
          message: "日付を選択してください。"
        });
        return;
      }
      var opt = {
        selectType: this.selectType,
        selectedStaff: this.selectedStaff,
        selectDays: this.selectDays
      };
      //親画面のbulkScheduleメソッドを呼び出し
      this.$emit("bulk-schedule-event", opt, this.targetYear, this.targetMonth);
      this.$parent.close();
    },
    addHolidaysStyle: function(day) {
      if (day.weekday == 1 || day.weekday == 7) {
        return { color: "red" };
      }
      for (var i = 0; i < this.holidayList.length; i++) {
        let tmpDay = this.formatDate3(this.holidayList[i].date);
        if (tmpDay == day.id) {
          return { color: "red" };
        }
      }
    },
    existRespiratory: function(day) {
      return this.respiratorySchedule.indexOf(day) >= 0;
    },
    existSleep: function(day) {
      return this.sleepSchedule.indexOf(day) >= 0;
    },
    pageChange(val) {
      this.targetYear = val.year;
      this.targetMonth = val.month;
      this.$parent.$parent.targetYear = val.year;
      this.$parent.$parent.workMonth = val.month;
    }
  },
  filters: {
    fillterOfficeName: function(val, officeMaster) {
      var office = officeMaster.find(v => v.officeCode === val);
      if (office) {
        return office.officeName;
      }
      return "";
    }
  },
  template: `
        <form action="">
          <div class="modal-card" style="width: 600px;">
            <header class="modal-card-head">
                <p class="modal-card-title" style="color: whitesmoke;">当番一括設定</p>
            </header>
            <section class="modal-card-body">
              <div style="height: 10px;" />
              <!-- 呼吸 or 睡眠 -->
              <div class="columns is-vcentered" style="width:100%;">
                <b-radio v-model="selectType" name="name" native-value='respiratoryStaff'>呼吸</b-radio>
                <b-radio v-model="selectType" name="name" native-value="sleepStaff">睡眠</b-radio>
                <span v-if="selectedStaff" style="margin-left:5%;font-size:18px;">前月：{{selectedStaff.lastMonthInCharge}}日 / 当月：{{selectedStaff.thisMonthInCharge}}日 / 翌月：{{selectedStaff.nextMonthInCharge}}日</span>
              </div>
              <!-- 担当者選択 -->
              <div style="height: 20px;" />
              <div class="columns is-vcentered">
                <b-field label="担当者" labelPosition="on-border" style="width:100%;">
                  <b-select expanded v-model="selectedStaff">
                    <option
                      v-for="menber in staffList"
                      :value="menber"
                      :key="menber.dutyStaffId"
                    >{{ menber.dutyStaffName }}　 ({{menber.dutyStaffNameKana}})　 ({{ menber.salesOfficeCode | fillterOfficeName(officeMaster) }})</option>
                  </b-select>
                </b-field>
              </div>
              <div style="height: 10px;" />
              <div class="columns is-vcentered">
                <!-- カレンダー -->
                <vc-calendar
                  :attributes="attributes"
                  style="width:100%;"
                  :min-date="startDate"
                  :max-date="endDate"
                  :first-day-of-week="2"
                  :from-page="{ month: targetMonth, year: targetYear }"
                  @update:fromPage="pageChange"
                >
                  <template slot="header-title" slot-scope="page">{{page.yearLabel}}年{{page.monthLabel}}</template>
                  <template slot="day-content" slot-scope="props">
                    <b-checkbox-button 
                      v-model="selectDays"
                      v-bind:native-value="props.day.id"
                      type="is-success">
                      <div v-bind:style="addHolidaysStyle(props.day)" style="width:50px;">
                        <div style="width: 50px;">{{props.day.day}}</div>
                        <div style="height: 10px; width: 50px; margin-bottom:5px; display: flex; flex-direction: row; justify-content: center; align-items: center;">
                          <div v-if="existRespiratory(props.day.id)"
                            style="height: 10px; width: 10px; border-radius: 50%;background: #006dd9;">
                          </div>
                          <div style="height: 10px; width: 5px;"></div>
                          <div v-if="existSleep(props.day.id)"
                            style="height: 10px; width: 10px; border-radius: 50%; background: sandybrown;">
                          </div>
                        </div>
                      </div>
                    </b-checkbox-button>
                  </template>
                </vc-calendar>
              </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="save">決定</button>
                <button class="button" type="button" @click="$parent.close()">閉じる</button>
            </footer>
          </div>
        </form>
      `
};

const scheduleHistoryTemplate = {
  props: ["app", "office", "type", "history", "roleId"],
  data() {
    var historyData = [];
    var td = new Date();
    td.setMonth(td.getMonth() - 2); // 2ヶ月前の日付
    td.setDate(1); // 最初の日
    var startDate = new Date(td);
    td = new Date();
    td.setMonth(td.getMonth() + 2); // 1ヶ月後の日付を求める
    td.setDate(0); // 前月の末日
    var endDate = new Date(td);
    return {
      startDate,
      endDate,
      historySearchErr: false,
      historyData
    };
  },
  methods: {
    getScheduleHisory: async function(startDate, endDate) {
      if (!startDate || !endDate) {
        // 検索条件の日付、営業所が指定されていない場合
        this.historySearchErr = true;
        return;
      }
      this.historySearchErr = false;
      this.historyModalActive = true;
      this.historyData = [];

      // ローディング画面表示セット
      this.app.loadingStart();

      // 待機当番スケジュールの変更履歴を取得する
      await this.$parent.$parent.historySearch(
        startDate,
        endDate,
        this.office,
        this.type
      );

      // 取得した変更履歴をセット
      this.historyData = this.history;
    },
    save: async function(event) {
      this.$emit("set-history-check", this.historyData);
      this.$parent.close();
    },
    close: async function(event) {
      this.historyData = [];
      this.$parent.close();
    }
  },
  filters: {
    fillterType: function(val) {
      switch (val) {
        case 1:
          return "呼吸";
          break;
        case 2:
          return "睡眠";
          break;
        case 3:
          return "呼吸/睡眠";
          break;
        default:
          return "";
          break;
      }
    }
  },
  mounted: function() {
    this.getScheduleHisory(this.startDate, this.endDate);
  },
  template: `
    <div class="modal-card" style="width: 100%;height: 100%;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">待機当番表変更履歴</p>
      </header>
      <div style="width:100%;margin-top:10px;">
        <div style="text-align: left;font-size:20px;">【検索条件】</div>
        <div style="margin-top:7px;padding-left:2%;">
          <b-field label="検索期間" labelPosition="on-border">
            <b-datepicker
              v-model="startDate"
              name="startDate"
              placeholder="検索開始年月日"
              icon="calendar-today"
              :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
              :day-names="['日','月','火','水','木','金','土']"
            ></b-datepicker>
            <b-datepicker
              v-model="endDate"
              name="endDate"
              placeholder="検索終了年月日"
              icon="calendar-today"
              :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
              :day-names="['日','月','火','水','木','金','土']"
            ></b-datepicker>
            <b-button
              class="button"
              style="margin-left:1%;"
              type="is-primary"
              icon-left
              native-type="button"
              v-on:click="getScheduleHisory(startDate,endDate)"
            >検索</b-button>
            <span
              v-if="historySearchErr"
              style="margin-left:3%; color: red;"
            >検索条件(開始日、終了日)を指定してください。</span>
          </b-field>
        </div>
      </div>
      <div style="border-top:solid 1px; border-color:lightgrey;" />
      <div style="text-align: left;font-size:20px;margin-top:10px;">【検索結果】</div>
      <section class="modal-card-body" style="height:70%;">
        <!-- <template v-for="(content, index) in historyData"> -->
        <template>
          <div>
            <div class="columns is-vcentered">
              <div style="width:100%;">
                <b-table :data="historyData">
                  <template slot-scope="props">
                    <b-table-column
                      field="date"
                      label="更新対象日"
                      sortable
                      centered
                    >{{ props.row.date}}</b-table-column>
                    <b-table-column
                      field="targetDuty"
                      label="対象当番"
                      sortable
                      centered
                    >{{ props.row.targetDuty | fillterType() }}</b-table-column>
                    <b-table-column
                      field="beforUserName"
                      label="更新前"
                      sortable
                      centered
                    >{{ props.row.beforUserName }}</b-table-column>
                    <b-table-column
                      field="afterUserName"
                      label="更新後"
                      sortable
                      centered
                    >{{ props.row.afterUserName }}</b-table-column>
                    <b-table-column
                      field="changeDate"
                      label="更新日"
                      sortable
                      centered
                    >{{ props.row.changeDate}}</b-table-column>
                    <b-table-column
                      field="updateUserName"
                      label="更新者"
                      sortable
                      centered
                    >{{ props.row.updateUserName}}</b-table-column>
                    <b-table-column
                      field="checkFlag"
                      label="機器安全センターチェック済"
                      sortable
                      centered
                    ><b-checkbox v-model="props.row.checkFlag" :disabled="roleId!=2"/>
                    </b-table-column>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </template>
      </section>
      <footer class="modal-card-foot">
        <button v-if="historyData.length>0 && roleId!=7" class="button" type="button" @click="save">登録(チェック情報)</button>
        <button class="button" type="button" @click="close">閉じる</button>
      </footer>
    </div>
`
};

const scheduleDownloadTemplate = {
  props: ["holiday", "attribute"],
  data() {
    var searchDate = new Date();
    var selectDays = [];
    selectDays.push(this.formatDate3(searchDate));
    return {
      searchDate,
      selectDays
    };
  },
  methods: {
    addHolidaysStyle: function(weekday, day) {
      if (weekday == 1 || weekday == 7) {
        return {
          color: "red"
        };
      }
      for (var i = 0; i < this.holiday.length; i++) {
        let tmpDay = this.formatDate3(this.holiday[i].date);
        if (tmpDay == day.id) {
          return { color: "red" };
        }
      }
    },
    changeDate: function(day, id) {
      this.selectDays = [];
      this.selectDays.push(id);
      this.searchDate = day;
    },
    scheduleDownload: async function(targetDate) {
      // ローディング画面表示セット
      // this.app.loadingStart();

      // 待機当番スケジュールの変更履歴を取得する
      await this.$parent.$parent.scheduleDownload(targetDate);
    },
    scheduleListDownload: async function() {
      // ローディング画面表示セット
      // this.app.loadingStart();

      // 待機当番スケジュールの変更履歴を取得する
      await this.$parent.$parent.scheduleListDownload();
    },
    save: async function(event) {
      this.$emit("set-history-check", this.historyData);
      this.$parent.close();
    }
  },
  template: `
  <form action="">
    <div class="modal-card" style="height:880px;width: 650px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">全国待機当番情報ダウンロード</p>
      </header>
      <section class="modal-card-body" style="width:100%;margin-top:10px;">
        <div style="margin-top:7px;width:100%;">
          <div style="text-align: left;font-size:20px;">【全国待機当番表】</div>
          <b-field style="text-align: left;">
          　<!-- カレンダー -->
            <vc-calendar
              :attributes="attribute"
              style="width:100%;"
              :first-day-of-week="2"
            >
              <template slot="header-title" slot-scope="page">{{page.yearLabel}}年{{page.monthLabel}}</template>
              <template slot="day-content" slot-scope="props">
                <b-checkbox-button
                  v-model="selectDays"
                  v-bind:native-value="props.day.id"
                  v-on:input="changeDate(props.day.date,props.day.id)"
                type="is-success">
                  <div v-bind:style="addHolidaysStyle(props.day.weekday,props.day)">
                    <div style="width: 50px;">{{props.day.day}}</div>
                    <div style="height: 10px; width: 50px; margin-bottom:5px; display: flex; flex-direction: row; justify-content: center; align-items: center;"></div>
                  </div>
                </b-checkbox-button>
              </template>
            </vc-calendar>
          </b-field>
          <b-field style="text-align: left;">
          　<b-button
              class="button"
              style="margin-left:5%;"
              type="is-primary"
              icon-left
              native-type="button"
              v-on:click="scheduleDownload(searchDate)"
            >ダウンロード</b-button>
            <span style="margin-left:10px;margin-top:3px;font-size:20px;">検索対象日付：{{this.formatDate2(searchDate)}}</span>
          </b-field>
        </div>
        <div style="height: 10px"></div>
        <div style="margin-top:20px;width:100%;">
          <div style="text-align: left;font-size:20px;margin-top:10px;">【全国待機当番リスト】</div>
          <b-field style="text-align: left;">
            <b-button
              class="button"
              style="margin-left:5%;"
              type="is-primary"
              icon-left
              native-type="button"
              v-on:click="scheduleListDownload()"
            >ダウンロード</b-button>
          </b-field>
        </div>
        <div style="height: 20px"></div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">閉じる</button>
      </footer>
    </div>
  </form>
`
};
export default {
  name: "AppUrgentSchedule",
  methods: {
    getHeader: function(name, kana, position) {
      if (!name && !kana && !position) {
        return "";
      } else {
        var positionInfo = this.positionMaster.find(
          v => v.positionCode === position
        );
        if (positionInfo) {
          return name + "(" + kana + ") / " + positionInfo.positionName;
        }
        return name + "(" + kana + ")";
      }
    },
    getuserName: function(value, length) {
      if (value) {
        return value.length > length ? value.substr(0, length) + "..." : value;
      }
      return value;
    },
    staffChanged: function(staff) {
      // 選択された担当者情報をモーダル画面から取得
      var code = staff.id;
      var name = staff.lastName + staff.firstName;
      var phone = staff.mobilePhoneNumber;
      var nameKana = staff.nameKana;
      var positionCode = staff.positionCode;
      var officeCode = staff.officeCode;
      if (phone != null) {
        phone = phone.replace(" ", "").replace("　", "");
      }
      var target = this.changedTarget.name;
      if (phone != null && phone != "") {
        // 画面に値設定
        if (target === "respiratoryManager") {
          // 呼吸マネージャー設定
          this.officeSchedule.respiratoryManagerCode = code;
          this.officeSchedule.respiratoryManagerName = name;
          this.officeSchedule.respiratoryManagerPhone = phone;
        } else if (target === "sleepManager") {
          // 睡眠マネージャー設定
          this.officeSchedule.sleepManagerCode = code;
          this.officeSchedule.sleepManagerName = name;
          this.officeSchedule.sleepManagerPhone = phone;
        } else if (target === "respiratoryLeader") {
          // 呼吸リーダー設定
          this.officeSchedule.respiratoryLeaderCode = code;
          this.officeSchedule.respiratoryLeaderName = name;
          this.officeSchedule.respiratoryLeaderPhone = phone;
        } else if (target === "sleepLeader") {
          // 睡眠リーダー設定
          this.officeSchedule.sleepLeaderCode = code;
          this.officeSchedule.sleepLeaderName = name;
          this.officeSchedule.sleepLeaderPhone = phone;
        } else if (target === "respiratoryStaff") {
          if (this.changedTarget.day == this.today) {
            this.officeSchedule.respiratoryStaffId = code;
            this.officeSchedule.respiratoryStaffName = name;
            this.officeSchedule.respiratoryStaffPhoneNumber = phone;
            this.officeSchedule.respiratoryStaffNameKana = nameKana;
            this.officeSchedule.respiratoryPositionCode = positionCode;
            this.officeSchedule.respiratoryOfficeCode = officeCode;
            this.respiratoryStaffMemo = staff.respiratoryMemo;
          }
          // 呼吸担当設定(カレンダー)
          var daySchedule = this.getDaySchedule(this.changedTarget.day);
          if (!daySchedule) {
            daySchedule = this.createDaySchedule(this.changedTarget.day);
          }
          daySchedule.respiratoryStaffCode = code;
          daySchedule.respiratoryStaffName = name;
          daySchedule.respiratoryStaffPhone = phone;
          var target = this.data.find(v => v.dutyStaffId == code);
          if (target) {
            target.respiratoryMemo = staff.respiratoryMemo;
          }
          this.officeSchedule.scheduledStaff.push({});
          this.officeSchedule.scheduledStaff.splice(
            this.officeSchedule.scheduledStaff.length - 1,
            1
          );
        } else if (target === "sleepStaff") {
          if (this.changedTarget.day == this.today) {
            this.officeSchedule.sleepStaffId = code;
            this.officeSchedule.sleepStaffName = name;
            this.officeSchedule.sleepStaffNameKana = nameKana;
            this.officeSchedule.sleepPositionCode = positionCode;
            this.officeSchedule.sleepStaffPhoneNumber = phone;
            this.officeSchedule.sleepOfficeCode = officeCode;
            this.sleepStaffMemo = staff.sleepMemo;
          }
          // 睡眠担当設定(カレンダー)
          var daySchedule = this.getDaySchedule(this.changedTarget.day);
          if (!daySchedule) {
            daySchedule = this.createDaySchedule(this.changedTarget.day);
          }
          daySchedule.sleepStaffCode = code;
          daySchedule.sleepStaffName = name;
          daySchedule.sleepStaffPhone = phone;
          var target = this.data.find(v => v.dutyStaffId == code);
          if (target) {
            target.sleepMemo = staff.sleepMemo;
          }
          this.officeSchedule.scheduledStaff.push({});
          this.officeSchedule.scheduledStaff.splice(
            this.officeSchedule.scheduledStaff.length - 1,
            1
          );
        }
      } else {
        // 携帯番号が存在しない場合
        this.showErrorMessage(
          "携帯電話番号が登録されているユーザを選択してください。"
        );
      }
      this.save();
    },
    getOfficeMaster: async function() {
      var excuteApi = this.getOfficeListPOST;
      var successCallBack = this.getOfficeListSuccess;
      var errorCallBack = this.getOfficeListError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getOfficeListPOST: function(client) {
      return client.apis.apiMaster.getOfficeListPOST({ body: {} });
    },
    getOfficeListSuccess: function(result) {
      var user = JSON.parse(sessionStorage.getItem("userInfo"));
      this.officeMaster = [];
      // WebAPI応答内容を画面に設定
      for (var i = 0; i < result.obj.length; i++) {
        var office = {
          officeCode: result.obj[i].officeCode,
          officeName: result.obj[i].officeName,
          phoneNumber: result.obj[i].phoneNumber,
          subCheckFlag: result.obj[i].subCheckFlag,
          mainTeamName: result.obj[i].mainTeamName,
          subTeamName: result.obj[i].subTeamName
        };
        // if (
        //   user.roleId === 1 ||
        //   user.roleId === 2 ||
        //   result.obj[i].officeCode === user.officeCode ||
        //   user.referenceOfficeCodes.indexOf(result.obj[i].officeCode) >= 0
        // ) {
        this.officeMaster.push(office);
        // }
      }
      // ローディング画面表示解除
      if (this.appVue.$data.isLoading) {
        this.appVue.loadingEnd();
      }
    },
    getOfficeListError: function(result) {
      this.showErrorMessage(result);
      // ローディング画面表示解除
      if (this.appVue.$data.isLoading) {
        this.appVue.loadingEnd();
      }
    },
    search: function(inChargeType, monthChangeFlag) {
      this.inChargeType = inChargeType;
      if (this.selectedOffice) {
        console.log("検索条件あり");
        var excuteApi = this.getUrgentSchedulePOST;
        var successCallBack = this.getUrgentScheduleSuccess;
        var errorCallBack = this.getUrgentScheduleError;
        // 作業月変更フラグ
        if (monthChangeFlag) {
          this.workMonthResetFlag = true;
        }
        // WebAPI Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      } else {
        console.log("検索条件未入力");
        this.isSearchConditionNull = true;
      }
    },
    //当番表取得処理
    getUrgentSchedulePOST: function(client) {
      var code = this.selectedOffice;
      var office = this.officeMaster.find(v => v.officeCode === code);
      var now = new Date().getHours();
      var nowDate = new Date();
      if (Number(now) < 9) {
        nowDate.setDate(nowDate.getDate() - 1);
      }
      this.today = this.formatDate3(nowDate);
      return client.apis.apiUrgentSchedule.getUrgentSchedulePOST({
        body: {
          officeCode: code,
          officeName: office.officeName,
          startDate: this.startDate,
          endDate: this.endDate,
          inChargeType: this.inChargeType
        }
      });
    },
    getUrgentScheduleSuccess: function(result) {
      if (this.replaceAllFlag) {
        // 画面データ全入れ替え
        if (result.data != "{}") {
          this.officeSchedule = result.obj.urgentScheduleList[0];
          this.respiratoryStaffMemo = this.officeSchedule.respiratoryStaffMemo;
          this.sleepStaffMemo = this.officeSchedule.sleepStaffMemo;

          for (var i in this.officeSchedule.scheduledStaff) {
            var regex = /\//gi;
            this.officeSchedule.scheduledStaff[
              i
            ].day = this.officeSchedule.scheduledStaff[i].day.replace(
              regex,
              "-"
            );
            this.officeSchedule.scheduledStaff[
              i
            ].respiratoryStaffCode = parseInt(
              this.officeSchedule.scheduledStaff[i].respiratoryStaffCode
            );
            this.officeSchedule.scheduledStaff[i].sleepStaffCode = parseInt(
              this.officeSchedule.scheduledStaff[i].sleepStaffCode
            );
          }
        } else {
          this.officeSchedule = {
            officeCode: this.selectedOffice,
            inChargeType: this.inChargeType,
            respiratoryManagerCode: null,
            respiratoryManagerName: "",
            respiratoryManagerPhone: "",
            respiratoryLeaderCode: null,
            respiratoryLeaderName: "",
            respiratoryLeaderPhone: "",
            sleepManagerCode: null,
            sleepManagerName: "",
            sleepManagerPhone: "",
            sleepLeaderCode: null,
            sleepLeaderName: "",
            sleepLeaderPhone: "",
            salesOfficeCode: null,
            sleepStaffName: "",
            respiratoryStaffName: "",
            sleepStaffKana: "",
            respiratoryStaffKana: "",
            respiratoryManagerId: null,
            respiratoryLeaderId: null,
            sleepManagerId: null,
            sleepLeaderId: null,
            respiratoryMobilePhoneNumber: "",
            sleepMobilePhoneNumber: "",
            sleepPhoneNumber: "",
            type: "",
            inChargeOfficeCode: "",
            scheduledStaff: [],
            urgentScheduleDutyList: []
          };
        }
        this.data = this.officeSchedule.urgentScheduleDutyList;
        this.searchedOffice = this.selectedOffice;

        this.renderKey = !this.renderKey;
      } else {
        // 待機当番リストのみ入れ替え
        if (result.data != "{}") {
          this.officeSchedule.urgentScheduleDutyList =
            result.obj.urgentScheduleList[0].urgentScheduleDutyList;
          this.data = this.officeSchedule.urgentScheduleDutyList;
          this.officeSchedule.sleepPhoneNumber =
            result.obj.urgentScheduleList[0].sleepPhoneNumber;
        } else {
          console.log("不明");
          this.data = this.officeSchedule.urgentScheduleDutyList;
        }
      }

      if (this.workMonthResetFlag) {
        // 作業月のリセット
        this.workMonth = new Date().getMonth() + 1;
        this.workMonthResetFlag = false;
      }

      this.isSearchConditionNull = false;
      this.replaceAllFlag = true;

      // ローディング画面表示解除
      if (this.appVue.$data.isLoading) {
        this.appVue.loadingEnd();
      }
    },
    getUrgentScheduleError: function(result) {
      this.showErrorMessage(result);
      // ローディング画面表示解除
      if (this.appVue.$data.isLoading) {
        this.appVue.loadingEnd();
      }
    },
    addStyleTextColor: function(weekday) {
      if (weekday === 1) {
        return {
          color: "red"
        };
      } else if (weekday === 7) {
        return {
          color: "#00c0ff"
        };
      }
    },
    addHolidaysStyle: function(weekday, day) {
      if (weekday == 1 || weekday == 7) {
        return {
          "background-color": "#ffbbff",
          color: "red"
        };
      }
      for (var i in this.holidays) {
        if (
          this.formatDate3(day.date) == this.formatDate3(this.holidays[i].date)
        ) {
          return {
            "background-color": "#ffbbff",
            color: "red"
          };
        }
      }
    },
    createDaySchedule: function(day) {
      var newDayElement = {
        day: day
      };
      this.officeSchedule.scheduledStaff.push(newDayElement);
      return newDayElement;
    },
    getDaySchedule: function(day) {
      var dayElement = this.officeSchedule.scheduledStaff.find(
        v => v.day === day
      );
      return dayElement;
    },
    getRespiratoryStaffInfo: function(day, type) {
      var daySchedule = this.getDaySchedule(day);
      if (daySchedule) {
        if (type === "phone") {
          return daySchedule.respiratoryStaffPhone;
        } else {
          return daySchedule.respiratoryStaffName;
        }
      }
      return " ";
    },
    getSleepStaffInfo: function(day, type) {
      var daySchedule = this.getDaySchedule(day);
      if (daySchedule) {
        if (type === "phone") {
          return daySchedule.sleepStaffPhone;
        } else {
          return daySchedule.sleepStaffName;
        }
      }
      return " ";
    },
    chengeStaff: function(target, day) {
      // リーダー選択、マネージャ選択、待機当番リスト担当者選択
      this.changedTarget.name = target;
      this.changedTarget.day = day;

      this.isStaffChangeModalActive = true;
      this.isStaffChangeModalFlag = false;
    },
    changeSelectStaff: function(target, day) {
      this.changedTarget.name = target;
      this.changedTarget.day = day;
      this.changedTarget.id = null;
      this.changedTarget.type = null;
      var daySchedule = this.getDaySchedule(this.changedTarget.day);
      this.dutyListData = [];
      var tempDutyList = [];
      var name = "呼吸/睡眠";
      switch (target) {
        case "respiratoryStaff":
          name = "呼吸";
          this.changedTarget.type = 1;
          tempDutyList = this.data.filter(
            val => val.type == 1 || val.type == 3
          );
          this.dutyListData = JSON.parse(JSON.stringify(tempDutyList));
          if (daySchedule) {
            this.changedTarget.id = daySchedule.respiratoryStaffCode;
          }
          break;
        case "sleepStaff":
          name = "睡眠";
          this.changedTarget.type = 2;
          tempDutyList = this.data.filter(
            val => val.type == 2 || val.type == 3
          );
          this.dutyListData = JSON.parse(JSON.stringify(tempDutyList));
          if (daySchedule) {
            this.changedTarget.id = daySchedule.sleepStaffCode;
          }
          break;
        default:
          tempDutyList = this.data;
          this.dutyListData = JSON.parse(JSON.stringify(tempDutyList));
          break;
      }
      if (this.dutyListData.length > 0) {
        this.isSelectStaffModal = true;
        this.isStaffChangeModalFlag = false;
      } else {
        this.showErrorMessage(
          "種別が「" + name + "」の待機当番リストが登録されていません。"
        );
      }
    },
    //登録処理
    save: function(event) {
      // setUrgentSchedule
      this.$validator.validateAll().then(result => {
        if (result) {
          var excuteApi = this.setUrgentSchedulePOST;
          var successCallBack = this.setUrgentScheduleSuccess;
          var errorCallBack = this.setUrgentScheduleError;
          // WebAPI Call
          this.apiCall(excuteApi, successCallBack, errorCallBack);
        } else {
          scrollTo(0, 0);
        }
      });
    },
    setUrgentSchedulePOST: function(client) {
      for (var i = 0; i < this.officeSchedule.scheduledStaff.length; i++) {
        var regex = /\-/gi;
        this.officeSchedule.scheduledStaff[
          i
        ].day = this.officeSchedule.scheduledStaff[i].day.replace(regex, "/");
      }
      var obj = JSON.parse(JSON.stringify(this.officeSchedule));
      return client.apis.apiUrgentSchedule.setUrgentSchedulePOST({
        body: obj
      });
    },
    setUrgentScheduleSuccess: function(result) {
      this.showSuccess(result);

      // 再取得
      var excuteApi = this.getUrgentSchedulePOST;
      var successCallBack = this.getUrgentScheduleSuccess;
      var errorCallBack = this.getUrgentScheduleError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setUrgentScheduleError: function(result) {
      this.showErrorMessage(result);
    },
    setUrgentScheduleError: function(result) {
      this.showErrorMessage(result);
    },
    openSelectStaff: function() {
      this.isStaffChangeModalActive = true;
      this.isStaffChangeModalFlag = true;
    },
    staffSet: function(staff) {
      var newObj = this.objInChageList.inChargeList[this.addIndex];
      staff.type = newObj.type;
      this.$set(this.objInChageList.inChargeList, this.addIndex, staff);
      // this.objInChageList.inChargeList[this.addIndex] = staff;
      this.addIndex = 0;
      this.isInChargeListModalActive = true;
    },
    registrationIncharge: function() {
      var excuteApi = this.setUrgentInChargeListPOST;
      var successCallBack = this.setUrgentInChargeListSuccess;
      var errorCallBack = this.setUrgentInChargeListError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setUrgentInChargeListPOST: function(client) {
      for (var i = 0; this.objInChageList.inChargeList.length > i; i++) {
        this.objInChageList.inChargeList[i].index = i;
      }
      return client.apis.apiUrgentSchedule.setUrgentInChargeListPOST({
        body: {
          inChargeOfficeCode: this.selectedOffice,
          inChargeType: this.inChargeType,
          sleepPhoneNumber: this.objInChageList.sleepPhoneNumber,
          inChargelist: this.objInChageList.inChargeList
        }
      });
    },
    setUrgentInChargeListSuccess: function(result) {
      this.showSuccess(result);
      this.replaceAllFlag = false;
      this.search(this.inChargeType);
    },
    setUrgentInChargeListError: function(result) {
      this.showErrorMessage(result);
    },
    getUrgentInChargeinformation: function(type) {
      this.informationFlag = type;
      var excuteApi = this.getUrgentInChargeinformationPOST;
      var successCallBack = this.getUrgentInChargeinformationSuccess;
      var errorCallBack = this.getUrgentInChargeinformationError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getUrgentInChargeinformationPOST: function(client) {
      return client.apis.apiUrgentSchedule.getUrgentInChargeinformationPOST({
        body: {
          inChargeOfficeCode: this.selectedOffice,
          inChargeType: this.inChargeType,
          userId: this.userinfo.id,
          getTypeFlag: this.informationFlag
        }
      });
    },
    getUrgentInChargeinformationSuccess: function(result) {
      this.otherData = result.obj;
      this.otherData.inChargeType = this.inChargeType;
      this.otherData.fixedFormRespiratoryMemo =
        result.obj.fixedFormRespiratoryMemo;
      this.otherData.fixedFormSleepMemo = result.obj.fixedFormSleepMemo;
      // 情報クリア
      this.changedTarget.name = "";

      this.isTemplateMessageActive = this.informationFlag == 0;
      this.isMainSubManagementActive = this.informationFlag == 1;
    },
    getUrgentInChargeinformationError: function(result) {
      this.showErrorMessage(result);
    },
    editInChargeList: function() {
      this.objInChageList.inChargeType = this.inChargeType;
      this.objInChageList.sleepPhoneNumber = this.officeSchedule.sleepPhoneNumber;
      this.objInChageList.inChargeList = [];
      if (this.data && this.data.length > 0) {
        for (var i = 0; this.data.length > i; i++) {
          this.objInChageList.inChargeList.push({
            index: this.data[i].index,
            type: this.data[i].type,
            dutyStaffId: this.data[i].dutyStaffId,
            dutyStaffCode: this.data[i].dutyStaffCode,
            dutyStaffName: this.data[i].dutyStaffName,
            dutyStaffNameKana: this.data[i].dutyStaffNameKana,
            dutyMobilePhoneNumber: this.data[i].dutyMobilePhoneNumber,
            salesOfficeCode: this.data[i].salesOfficeCode,
            salesOfficeName: this.getOfficeName(this.data[i].salesOfficeCode)
          });
        }
      } else {
        this.objInChageList.inChargeList = [
          {
            index: 0,
            type: "",
            dutyStaffId: "",
            dutyStaffCode: "",
            dutyStaffName: "",
            dutyStaffNameKana: "",
            dutyMobilePhoneNumber: "",
            salesOfficeCode: ""
          }
        ];
      }
      this.isInChargeListModalActive = true;
    },
    staffDelete: function() {
      if (this.isStaffChangeModalFlag) {
        this.$set(this.objInChageList.inChargeList, this.addIndex, {});
        this.addIndex = 0;
        this.isInChargeListModalActive = true;
        return;
      }
      var target = this.changedTarget.name;
      // 画面に値設定
      if (target === "respiratoryManager") {
        // 呼吸マネージャー削除
        this.officeSchedule.respiratoryManagerCode = null;
        this.officeSchedule.respiratoryManagerName = null;
        this.officeSchedule.respiratoryManagerPhone = null;
      } else if (target === "sleepManager") {
        // 睡眠マネージャー削除
        this.officeSchedule.sleepManagerCode = null;
        this.officeSchedule.sleepManagerName = null;
        this.officeSchedule.sleepManagerPhone = null;
      } else if (target === "respiratoryLeader") {
        // 呼吸リーダー削除
        this.officeSchedule.respiratoryLeaderCode = null;
        this.officeSchedule.respiratoryLeaderName = null;
        this.officeSchedule.respiratoryLeaderPhone = null;
      } else if (target === "sleepLeader") {
        // 睡眠リーダー削除
        this.officeSchedule.sleepLeaderCode = null;
        this.officeSchedule.sleepLeaderName = null;
        this.officeSchedule.sleepLeaderPhone = null;
      } else if (target === "respiratoryStaff") {
        // 呼吸担当削除(カレンダー)
        if (this.changedTarget.day == this.today) {
          this.officeSchedule.respiratoryStaffId = null;
          this.officeSchedule.respiratoryStaffName = null;
          this.officeSchedule.respiratoryStaffPhoneNumber = null;
          this.officeSchedule.respiratoryStaffNameKana = null;
          this.officeSchedule.respiratoryPositionCode = null;
          this.officeSchedule.respiratoryOfficeCode = null;
          this.respiratoryStaffMemo = null;
        }
        var daySchedule = this.getDaySchedule(this.changedTarget.day);
        if (!daySchedule) {
          daySchedule = this.createDaySchedule(this.changedTarget.day);
        }
        daySchedule.respiratoryStaffCode = null;
        daySchedule.respiratoryStaffName = null;
        daySchedule.respiratoryStaffPhone = null;
        daySchedule.respiratoryStaffId = null;
        this.officeSchedule.scheduledStaff.push({});
        this.officeSchedule.scheduledStaff.splice(
          this.officeSchedule.scheduledStaff.length - 1,
          1
        );
      } else if (target === "sleepStaff") {
        // 睡眠担当削除(カレンダー)
        if (this.changedTarget.day == this.today) {
          this.officeSchedule.sleepStaffId = null;
          this.officeSchedule.sleepStaffName = null;
          this.officeSchedule.sleepStaffNameKana = null;
          this.officeSchedule.sleepPositionCode = null;
          this.officeSchedule.sleepStaffPhoneNumber = null;
          this.officeSchedule.sleepOfficeCode = null;
          this.sleepStaffMemo = null;
        }
        var daySchedule = this.getDaySchedule(this.changedTarget.day);
        if (!daySchedule) {
          daySchedule = this.createDaySchedule(this.changedTarget.day);
        }
        daySchedule.sleepStaffCode = null;
        daySchedule.sleepStaffName = null;
        daySchedule.sleepStaffPhone = null;
        daySchedule.sleepStaffId = null;

        this.officeSchedule.scheduledStaff.push({});
        this.officeSchedule.scheduledStaff.splice(
          this.officeSchedule.scheduledStaff.length - 1,
          1
        );
      }
      this.save();
    },
    saveTemplateMessage: function(memoData) {
      var excuteApi = this.setUrgentMemoListPOST;
      var successCallBack = this.setUrgentMemoListSuccess;
      var errorCallBack = this.setUrgentMemoListError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setUrgentMemoListPOST: function(client) {
      return client.apis.apiUrgentSchedule.setUrgentMemoListPOST({
        body: {
          userId: this.userinfo.id,
          inChargeType: this.inChargeType,
          inChargeOfficeCode: this.selectedOffice,
          fixedFormRespiratoryMemo: this.otherData.fixedFormRespiratoryMemo,
          fixedFormSleepMemo: this.otherData.fixedFormSleepMemo
        }
      });
    },
    setUrgentMemoListSuccess: function(result) {
      this.showSuccess(result);
      this.replaceAllFlag = false;
      this.search(this.inChargeType);
    },
    setUrgentMemoListError: function(result) {
      this.showErrorMessage(result);
    },
    saveTeamList: async function() {
      var excuteApi = this.setUrgentInChargeTeamListPOST;
      var successCallBack = this.setUrgentInChargeTeamListSuccess;
      var errorCallBack = this.setUrgentInChargeTeamListError;

      // ローディング画面表示セット
      this.appVue.loadingStart();

      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);

      // 営業所マスタ取得
      await this.getOfficeMaster();

      this.selectOffice();
    },
    setUrgentInChargeTeamListPOST: function(client) {
      return client.apis.apiUrgentSchedule.setUrgentInChargeTeamListPOST({
        body: {
          urgentOfficeList: this.otherData.urgentOfficeList
        }
      });
    },
    setUrgentInChargeTeamListSuccess: function(result) {
      this.showSuccess(result);
    },
    setUrgentInChargeTeamListError: function(result) {
      this.showErrorMessage(result);
    },
    getOfficeName: function(val) {
      var office = this.officeFilterMaster.find(v => v.officeCode === val);
      if (office) {
        return office.officeName;
      }
      return "";
    },
    selectOffice: function() {
      // 選択営業所のサブチェックフラグセット
      var office = this.officeMaster.find(
        v => v.officeCode == this.selectedOffice
      );
      this.isActive = office.subCheckFlag;
    },
    getTeamName: function(inChargeType) {
      if (this.selectedOffice && this.isActive) {
        var office = this.officeMaster.find(
          v => v.officeCode == this.selectedOffice
        );
        var target;
        if (inChargeType == 1) {
          target = office.mainTeamName
            ? office.mainTeamName.replace(/\s+/g, "")
            : "";
          return target.length != 0
            ? office.mainTeamName + "を検索する"
            : "検索する";
        } else if (inChargeType == 2) {
          target = office.subTeamName
            ? office.subTeamName.replace(/\s+/g, "")
            : "";
          return target.length != 0
            ? office.subTeamName + "を検索する"
            : "検索する";
        }
      } else {
        return "検索する";
      }
    },
    showBulkScheduleModal: function() {
      //呼吸で当番が割り当てられいる日
      this.respiratorySchedule = [];
      //睡眠で当番が割り当てられている日
      this.sleepSchedule = [];
      for (var i = 0; i < this.officeSchedule.scheduledStaff.length; i++) {
        var schedule = this.officeSchedule.scheduledStaff[i];
        if (schedule.respiratoryStaffCode) {
          this.respiratorySchedule.push(schedule.day);
        }
        if (schedule.sleepStaffCode) {
          this.sleepSchedule.push(schedule.day);
        }
      }

      this.isBulkScheduleModalActive = true;
    },
    pageChange(val) {
      this.targetYear = val.year;
      this.workMonth = val.month;
    },
    bulkSchedule: function(arg, year, month) {
      //スケジュール一括更新 (当番一括設定画面から呼ばれる)
      let selectType = arg.selectType;
      let selectedStaffId = arg.selectedStaff.dutyStaffId;
      let selectedStaffName = arg.selectedStaff.dutyStaffName;
      let selectedStaffPhone = arg.selectedStaff.dutyMobilePhoneNumber;

      for (var day of arg.selectDays) {
        var daySchedule = this.getDaySchedule(day);
        if (!daySchedule) {
          daySchedule = this.createDaySchedule(day);
        }
        if (selectType === "respiratoryStaff") {
          //呼吸
          daySchedule.respiratoryStaffCode = selectedStaffId;
          daySchedule.respiratoryStaffName = selectedStaffName;
          daySchedule.respiratoryStaffPhone = selectedStaffPhone;
          //当日だったら当番表を更新する
          if (day == this.today) {
            this.officeSchedule.respiratoryStaffId = selectedStaffId;
            this.officeSchedule.respiratoryStaffName = selectedStaffName;
            this.officeSchedule.respiratoryStaffPhoneNumber = selectedStaffPhone;
            this.officeSchedule.respiratoryStaffNameKana =
              arg.selectedStaff.dutyStaffNameKana;
            this.officeSchedule.respiratoryPositionCode =
              arg.selectedStaff.positionCode;
            this.officeSchedule.respiratoryOfficeCode =
              arg.selectedStaff.salesOfficeCode;
            this.respiratoryStaffMemo = arg.selectedStaff.respiratoryMemo;
          }
        } else if (selectType === "sleepStaff") {
          //睡眠
          daySchedule.sleepStaffCode = selectedStaffId;
          daySchedule.sleepStaffName = selectedStaffName;
          daySchedule.sleepStaffPhone = selectedStaffPhone;
          if (day == this.today) {
            this.officeSchedule.sleepStaffId = selectedStaffId;
            this.officeSchedule.sleepStaffName = selectedStaffName;
            this.officeSchedule.sleepStaffPhoneNumber = selectedStaffPhone;
            this.officeSchedule.sleepStaffNameKana =
              arg.selectedStaff.dutyStaffNameKana;
            this.officeSchedule.sleepPositionCode =
              arg.selectedStaff.positionCode;
            this.officeSchedule.sleepOfficeCode =
              arg.selectedStaff.salesOfficeCode;
            this.sleepStaffMemo = arg.selectedStaff.sleepMemo;
          }
        }
      }
      //画面の更新
      this.officeSchedule.scheduledStaff.push({});
      this.officeSchedule.scheduledStaff.splice(
        this.officeSchedule.scheduledStaff.length - 1,
        1
      );
      this.save();
      this.targetYear = year;
      this.workMonth = month;
      this.renderKey = !this.renderKey;
    },

    getScheduleHisory: function() {
      this.historyModalActive = true;
    },
    // 待機当番表の変更履歴取得
    historySearch: async function(startDate, endDate, office, type) {
      this.historyStartDate = startDate;
      this.historyEndDate = endDate;
      var excuteApi = this.getUrgentScheduleHistoryPOST;
      var successCallBack = this.getUrgentScheduleHistorySuccess;
      var errorCallBack = this.getUrgentScheduleHistoryError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getUrgentScheduleHistoryPOST: function(client) {
      return client.apis.apiUrgentSchedule.getUrgentScheduleHistoryPOST({
        body: {
          officeCode: this.selectedOffice,
          startDate: this.historyStartDate,
          endDate: this.historyEndDate,
          inChargeType: this.inChargeType
        }
      });
    },
    getUrgentScheduleHistorySuccess: function(result) {
      this.historyData = result.obj;
      // ローディング画面表示解除
      if (this.appVue.$data.isLoading) {
        this.appVue.loadingEnd();
      }
    },
    getUrgentScheduleHistoryError: function(result) {
      this.showErrorMessage(result);
      // ローディング画面表示解除
      if (this.appVue.$data.isLoading) {
        this.appVue.loadingEnd();
      }
    },
    // 待機当番表の変更履歴登録(チェック情報)
    historyCheckUpdate: async function(history) {
      this.historyData = history;
      var excuteApi = this.setUrgentScheduleHistoryPOST;
      var successCallBack = this.setUrgentScheduleHistorySuccess;
      var errorCallBack = this.setUrgentScheduleHistoryError;
      // WebAPI Call
      await this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setUrgentScheduleHistoryPOST: function(client) {
      return client.apis.apiUrgentSchedule.setUrgentScheduleHistoryPOST({
        body: {
          userId: this.userinfo.id,
          histories: this.historyData
        }
      });
    },
    setUrgentScheduleHistorySuccess: function(result) {
      this.showSuccess(result);
    },
    setUrgentScheduleHistoryError: function(result) {
      this.showErrorMessage(result);
    },
    // 待機当番表ダウンロード(全国の当日分)
    scheduleDownload: function(targetDate) {
      this.searchDate = this.formatDate2(targetDate);
      var excuteApi = this.downloadScheduleFilePOST;
      var errorCallBack = this.downloadScheduleFileError;
      // WebAPI Call
      this.downloadApiCall(excuteApi, errorCallBack);
    },
    downloadScheduleFilePOST: function(client) {
      return client.apis.apiUrgentSchedule.downloadScheduleFilePOST({
        body: {
          date: this.searchDate
        }
      });
    },
    downloadScheduleFileError: function(result) {
      this.showErrorMessage(result);
    },
    // 待機当番リストダウンロード(全国の待機当番リスト)
    scheduleListDownload: function() {
      var excuteApi = this.downloadScheduleListPOST;
      var errorCallBack = this.downloadScheduleListError;
      // WebAPI Call
      this.downloadApiCall(excuteApi, errorCallBack);
    },
    downloadScheduleListPOST: function(client) {
      return client.apis.apiUrgentSchedule.downloadScheduleListPOST({});
    },
    downloadScheduleListError: function(result) {
      this.showErrorMessage(result);
    }
  },
  data() {
    var appVue = this.$root.$children[0];
    var now = new Date();
    var headerYearMonth =
      now.getFullYear() + "年 " + (now.getMonth() + 1) + "月度";
    // 現在日付を取得
    var today = now.getDate();
    if (today == 1) {
      // 月初の場合、9時以降か判定
      if (Number(now.getHours()) < 9) {
        // 9時以前の場合、前月でタイトルセット
        headerYearMonth = now.getFullYear() + "年 " + now.getMonth() + "月度";
      }
    }

    var data = [];
    var userinfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var officeMaster = [];
    var officeFilterMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    var positionMaster = JSON.parse(sessionStorage.getItem("positionMaster"));
    var roleId = userinfo.roleId;
    var srcRoleId = userinfo.srcRoleId;
    var editableOfficeList = [];
    editableOfficeList.push(userinfo.officeCode);
    for (var i = 0; i < userinfo.referenceOfficeCodes.length; i++) {
      editableOfficeList.push(userinfo.referenceOfficeCodes[i]);
    }

    //検索条件を前後1か月間(前月初日～翌日末日）にする。
    //ロジックは以下のとおり
    // ・startDate:本日の日付取得->前月の日付を求める->月初の日付を取得(setDate(1))
    // ・endDate　:本日の日付取得->翌々月の日付を求める->前月末日の日付を取得(setDate(0))
    var td = new Date();
    td.setMonth(td.getMonth() - 1); //前月の日付
    td.setDate(1); //最初の日
    var startDate = this.formatDate(new Date(td));
    td = new Date();
    td.setMonth(td.getMonth() + 4); //3ヶ月後の日付を求める
    td.setDate(0); //前月の末日
    var endDate = this.formatDate(new Date(td));
    //当月から当月から1ヶ月前、当月から3ヶ月後の間にある祝日を取得する
    var dt = new Date();
    var holiday_jp = require("@holiday-jp/holiday_jp");
    var holidays = holiday_jp.between(
      new Date(dt.getFullYear(), dt.getMonth() - 1, 1),
      new Date(dt.getFullYear(), dt.getMonth() + 4, 0)
    );
    
    var isEdit = srcRoleId != 7
    return {
      isEdit,
      data,
      respiratoryStaffMemo: "",
      sleepStaffMemo: "",
      today: this.formatDate3(new Date()),
      startDate,
      endDate,
      officeMaster,
      userinfo,
      selectedOffice: "",
      searchedOffice: "",
      isSearchConditionNull: false,
      historyModalActive: false,
      officeSchedule: [],
      changedTarget: {
        name: "",
        day: "",
        id: null,
        type: null
      },
      isStaffChangeModalActive: false,
      isSelectStaffModal: false,
      roleId,
      srcRoleId,
      editableOfficeList,
      attributes: [
        {
          highlight: {
            backgroundColor: "#ff8080"
          },
          dates: [new Date()]
        }
      ],
      targetYear: new Date().getFullYear(),
      workMonth: new Date().getMonth() + 1,
      workMonthResetFlag: false,
      isInChargeListModalActive: false,
      isTemplateMessageActive: false,
      isMainSubManagementActive: false,
      isStaffChangeModalFlag: false,
      addIndex: 0,
      informationFlag: null,
      urgentOfficeList: null,
      inChargeType: 1,
      positionMaster,
      headerYearMonth,
      appVue,
      isActive: true,
      replaceAllFlag: true,
      officeFilterMaster,
      // 待機当番リスト編集で使用(コンポーネント用変数)
      objInChageList: {
        inChargeType: null,
        sleepPhone: "",
        inChargeList: []
      },
      // スケジュールの担当者選択で使用(コンポーネント用変数)
      dutyListData: [],
      // メイン・サブ管理で使用(コンポーネント用変数)
      otherData: {
        fixedFormRespiratoryMemo: "",
        fixedFormSleepMemo: "",
        urgentOfficeList: []
      },
      //祝日(当月から1ヶ月前~3ヶ月後)用変数
      holidays,
      historyData: [],
      historyStartDate: null,
      historyEndDate: null,
      downloadModalActive: false,
      searchDate: null,
      //待機当番一括設定用変数
      isBulkScheduleModalActive: false,
      respiratorySchedule: [],
      sleepSchedule: [],
      // レンダリング用のフラグ
      renderKey: true
    };
  },
  components: {
    "staffChange-modal": ModalForm,
    "select-staff-modal": selectStaffModal,
    "in-charge-list-modal": inChargeListModal,
    "template-messeage-modale": templateMesseageModale,
    "main-sub-management-modal": mainSubManagementModal,
    "schedule-history-modal": scheduleHistoryTemplate,
    "schedule-download-modal": scheduleDownloadTemplate,
    "bulk-schedule-modal": BulkScheduleModal
  },
  filters: {
    fillterOfficeName: function(val, officeMaster) {
      var office = officeMaster.find(v => v.officeCode === val);
      if (office) {
        return office.officeName;
      }
      return "";
    },
    fillterType: function(val) {
      switch (val) {
        case 1:
          return "呼吸";
          break;
        case 2:
          return "睡眠";
          break;
        case 3:
          return "呼吸/睡眠";
          break;
        default:
          return "";
          break;
      }
    }
  },
  async mounted() {
    // ローディング画面表示セット
    this.appVue.loadingStart();
    // 営業所マスタ取得
    await this.getOfficeMaster();

    if (this.roleId != 1 && this.roleId != 2 && this.roleId != 7) {
      this.selectedOffice = this.userinfo.officeCode;

      // 選択営業所のサブチェックフラグセット
      var office = this.officeMaster.find(
        v => v.officeCode == this.selectedOffice
      );
      this.isActive = office.subCheckFlag;

      // 初期表示として、メインを検索
      this.search(1);
    }
  },
  watch: {
    respiratoryStaffMemo(val) {
      this.officeSchedule.respiratoryStaffMemo = val;
      var target = this.data.find(
        v => v.dutyStaffId == this.officeSchedule.respiratoryStaffId
      );
      if (target) {
        target.respiratoryMemo = val;
      }
    },
    sleepStaffMemo(val) {
      this.officeSchedule.sleepStaffMemo = val;
      var target = this.data.find(
        v => v.dutyStaffId == this.officeSchedule.sleepStaffId
      );
      if (target) {
        target.sleepMemo = val;
      }
    }
  },
  computed: {
    respiratoryManager: {
      get: function() {
        if (this.officeSchedule.respiratoryManagerPhone) {
          return (
            this.getuserName(this.officeSchedule.respiratoryManagerName, 16) +
            " (" +
            this.officeSchedule.respiratoryManagerPhone +
            ")"
          );
        }
      }
    },
    respiratoryLeader: {
      get: function() {
        if (this.officeSchedule.respiratoryLeaderPhone) {
          return (
            this.getuserName(this.officeSchedule.respiratoryLeaderName, 16) +
            " (" +
            this.officeSchedule.respiratoryLeaderPhone +
            ")"
          );
        }
      }
    },
    sleepManager: {
      get: function() {
        if (this.officeSchedule.sleepManagerPhone) {
          if (this.officeSchedule.sleepManagerPhone) {
            return (
              this.getuserName(this.officeSchedule.sleepManagerName, 16) +
              " (" +
              this.officeSchedule.sleepManagerPhone +
              ")"
            );
          }
        }
      }
    },
    sleepLeader: {
      get: function() {
        if (this.officeSchedule.sleepLeaderPhone) {
          return (
            this.getuserName(this.officeSchedule.sleepLeaderName, 16) +
            " (" +
            this.officeSchedule.sleepLeaderPhone +
            ")"
          );
        }
      }
    },
    // isEditableOffice: function() {
    //   var ret = false;
    //   if (this.roleId === 1) {
    //     ret = true;
    //   } else if (this.roleId === 3 || this.roleId === 4) {
    //     ret = this.editableOfficeList.includes(this.searchedOffice);
    //   }
    //   return ret;
    // },
    fillterInChargeType: function() {
      if (this.officeSchedule.teamName && this.isActive) {
        return this.officeSchedule.teamName;
      } else {
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.scheduleItem {
  font-size: 5px;
  height: 43px;
  word-break: break-all;
  margin-right: 2px;
  margin-left: 2px;
  padding: 0.5em 0.5em;
  border-radius: 10px; /*角の丸み*/
  position: relative;
  overflow: hidden;
}
.respiratoryDiv {
  background: #89b5f0;
}
.kindMark {
  padding: 3px 5px;
  height: 43px;
  color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 10px 0px 0px 0px; /*上の丸み*/
  display: table;
}
.respiratoryDiv > .kind {
  background: #006dd9;
}
.sleepDiv {
  background: papayawhip;
}
.sleepDiv > .kind {
  background: sandybrown;
}
.kindLabel {
  font-size: 15px;
  display: table-cell;
  vertical-align: middle;
}
.scheduledName {
  width: 100%;
  height: 43px;
  padding-right: 5px;
  padding-left: 30px;
  text-align: left;
  font-size: 15px;
  font-weight: bolder;
  display: table-cell;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/AppUrgentSchedule.vue